import React, { useState, useEffect } from 'react';

import { fetchAllAirlines, doSaveExcludedAirlines } from 'actions/airlineException';
import useStoreTranslation from 'hooks/useStoreTranslation';
import useToast from 'hooks/useToast';
import { Airline } from 'models/airlineException';
import AirlinesList from 'screens/components/AirlinesList';
import { extractErrorMessage } from 'utils/generic';

interface Props {
  show: boolean;
  companyId: string;
  excludeAirlines: string[];
  close: () => void;
  onSaveCallBack: () => void;
}

const AirlinesListContainer = ({ show, close, excludeAirlines, companyId, onSaveCallBack }: Props) => {
  const [data, setData] = useState<Airline[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selecteds, setSelecteds] = useState<string[]>([]);

  const toast = useToast();
  const { t } = useStoreTranslation();

  const handleSelect = (id: string) => {
    let newData = [...selecteds];
    if (selecteds.includes(id)) {
      newData = selecteds.filter((element) => element !== id);
    } else {
      newData.push(id);
    }
    setSelecteds(newData);
  };

  const handleSave = async () => {
    const newData = {
      airlinesIds: selecteds,
      companyId,
    };

    try {
      setIsSubmitting(true);
      await doSaveExcludedAirlines(newData);
      onSaveCallBack();
    } catch (error) {
      toast.add({
        type: 'danger',
        message: extractErrorMessage(error) || t('defaultError.default'),
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    setSelecteds([]);
    if (show) {
      setIsLoading(true);
      fetchAllAirlines()
        .then((res) => {
          const filteredAirlines = res.data.data.filter((airline) => !excludeAirlines.includes(airline.id));
          setData(filteredAirlines);
        })
        .catch((error) => {
          toast.add({
            type: 'danger',
            message: extractErrorMessage(error) || t('defaultError.default'),
          });
        })
        .finally(() => setIsLoading(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  return (
    <AirlinesList
      show={show}
      airlines={data}
      isLoading={isLoading}
      isSubmitting={isSubmitting}
      selecteds={selecteds}
      onClose={close}
      onSave={handleSave}
      onSelect={handleSelect}
    />
  );
};

export default AirlinesListContainer;
